import { getRequestInstance } from "api/services/utils";
import { RequestTypes } from "api/services/enums";
import { executeEviction } from "api/utils/cache-eviction";
import { client } from "config/apollo";
import {
  HrCapitalFormationTierGetByIdDocument,
  HrCapitalFormationTierCreateDocument,
  HrCapitalFormationTierUpdateDocument,
  HrCapitalFormationTierDeleteDocument,
  HrCapitalFormationTierListPaginatedDocument,
} from "api/generated";
import { Optional } from "config";

import {
  IHrCapitalFormationTierModel,
  IHrCapitalFormationTierUpdateVars,
  IHrCapitalFormationTierCreateVars,
  IHrCapitalFormationTierPaginatedVars,
  IHrCapitalFormationTierPaginatedResponse,
} from "./types";

export async function getHrCapitalFormationTierPaginated(
  variables: IHrCapitalFormationTierPaginatedVars
): Promise<Optional<IHrCapitalFormationTierPaginatedResponse>> {
  try {
    const makeRequest = getRequestInstance(RequestTypes.QUERY);
    const res = await makeRequest({
      query: HrCapitalFormationTierListPaginatedDocument,
      variables,
      fetchPolicy: "network-only",
    });

    return res?.data?.hrCapitalFormationTierListPaginated;
  } catch (error) {
    throw error;
  }
}

export async function getHrCapitalFormationTierById(
  id: number
): Promise<IHrCapitalFormationTierModel> {
  try {
    const makeRequest = getRequestInstance(RequestTypes.QUERY);
    const res = await makeRequest({
      query: HrCapitalFormationTierGetByIdDocument,
      variables: {
        id,
      },
      fetchPolicy: "network-only",
    });

    return res?.data?.hrCapitalFormationTierGetById ?? {};
  } catch (error) {
    throw error;
  }
}

export async function createHrCapitalFormationTier(
  input: IHrCapitalFormationTierCreateVars
): Promise<boolean> {
  try {
    const makeRequest = getRequestInstance(RequestTypes.MUTATE);
    const res = await makeRequest({
      mutation: HrCapitalFormationTierCreateDocument,
      variables: input,
      fetchPolicy: "no-cache",
    });

    executeEviction(client, {
      typename: "HrCapitalFormationTier",
      fieldNames: ["hrCapitalFormationTierListPaginated"],
    });

    return res?.data?.hrCapitalFormationTierCreate ?? false;
  } catch (error) {
    throw error;
  }
}

export async function updateHrCapitalFormationTier(
  input: IHrCapitalFormationTierUpdateVars
): Promise<boolean> {
  try {
    const makeRequest = getRequestInstance(RequestTypes.MUTATE);
    const res = await makeRequest({
      mutation: HrCapitalFormationTierUpdateDocument,
      variables: input,
      fetchPolicy: "no-cache",
    });

    executeEviction(client, {
      typename: "HrCapitalFormationTier",
      id: input.id?.toString(),
      fieldNames: [
        "hrCapitalFormationTierListPaginated",
        "hrCapitalFormationTierGetById",
      ],
    });

    return res?.data?.hrCapitalFormationTierUpdate ?? false;
  } catch (error) {
    throw error;
  }
}

export async function deleteHrCapitalFormationTier(
  id: number
): Promise<boolean> {
  try {
    const makeRequest = getRequestInstance(RequestTypes.MUTATE);
    const res = await makeRequest({
      mutation: HrCapitalFormationTierDeleteDocument,
      variables: {
        id,
      },
      fetchPolicy: "no-cache",
    });

    executeEviction(client, {
      typename: "HrCapitalFormationTier",
      id: id.toString(),
      fieldNames: [
        "hrCapitalFormationTierListPaginated",
        "hrCapitalFormationTierGetById",
      ],
    });

    return res?.data?.hrCapitalFormationTierDelete ?? false;
  } catch (error) {
    throw error;
  }
}
